import { hub } from './hub'

/** Channels an admin is viewing without membership (need explicit Subscribe). */
const adminSubscriptions = new Set<string>()
let focusedChannelId: string | null = null

export function subscribeAdminChannel(channelId: string): void {
  adminSubscriptions.add(channelId)
  void hub.subscribe(channelId)
}

export function unsubscribeAdminChannel(channelId: string): void {
  if (!adminSubscriptions.delete(channelId)) return
  void hub.unsubscribe(channelId)
}

export function setFocusedChannel(channelId: string | null): void {
  if (focusedChannelId === channelId) return
  focusedChannelId = channelId
  void hub.setFocused(channelId)
}

export function getFocusedChannel(): string | null {
  return focusedChannelId
}

/** Re-apply per-connection state after (re)connecting. */
export function restoreConnectionState(): void {
  for (const id of adminSubscriptions) void hub.subscribe(id)
  if (focusedChannelId) void hub.setFocused(focusedChannelId)
}
